import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export function SystemStatusBanner() {
  const [dismissed, setDismissed] = useState(false);

  const { data: issues = [] } = useQuery({
    queryKey: ["system-status-banner"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("platform_status")
        .select("service_name, status")
        .neq("status", "operational");
      if (error) return [];
      return data || [];
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

  if (dismissed || issues.length === 0) return null;

  return (
    <div className="bg-yellow-500/10 border-b border-yellow-500/20 px-4 py-2">
      <div className="container mx-auto flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm">
          <AlertTriangle className="h-4 w-4 text-yellow-600 dark:text-yellow-400 shrink-0" />
          <span className="text-yellow-800 dark:text-yellow-200">
            Some services are experiencing issues. Our team is investigating.{" "}
            <Link to="/status" className="underline font-medium hover:no-underline">
              View status
            </Link>
          </span>
        </div>
        <button onClick={() => setDismissed(true)} className="text-yellow-600 dark:text-yellow-400 hover:opacity-70">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
